export function isEmpty(value) {
    if (typeof value === "string") {
        return value.trim() === "";
    }
    return true;
}

// Function to validate a phone number (must be exactly 10 digits)
export function isValidPhoneNumber(value) {
    if (typeof value === "string") {
        // Remove non-digit characters
        const numericValue = value.replace(/\D/g, '');
        // Check if the numeric value consists of exactly 10 digits
        return /^\d{10}$/.test(numericValue);
    }
    return false;
}
export const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  export function isValidDate(value) {
    // If the value is a Date object, check if it's valid
    if (Object.prototype.toString.call(value) === "[object Date]" && !isNaN(value.getTime())) {
        return true;
    }

    // If the value is a string, attempt to validate the format "YYYY-MM-DD" explicitly
    if (typeof value === "string") {
        const datePattern = /^\d{4}-\d{2}-\d{2}$/; // Regex to match "YYYY-MM-DD" format
        if (datePattern.test(value)) {
            const date = new Date(value + "T00:00:00"); // Convert to ISO format to avoid time zone issues
            return !isNaN(date.getTime());
        }
    }

    return false;
}

export function validateMaxLength(value, maxLength) {
    if (typeof value === "string") {
        return value.length <= maxLength;
    }
    return false; // If value is not a string, return false
}
export function validateAmount(value, min = 0) {
    // Ensure the value is a number and greater than or equal to the minimum
    return !isNaN(value) && value >= min;
}

export function addPercentage(newPercentage,data) {

    newPercentage = Number(newPercentage);
    let currentTotal = data.reduce((sum, item) => sum + item.allocationPercentage, 0);
    currentTotal = Number(currentTotal);
    console.log("current toal",currentTotal + newPercentage);
    if (currentTotal + newPercentage <= 100) {
      console.log(`Added: ${JSON.stringify(newPercentage)}`);
      return true
    } else {
      console.log('Total percentage cannot exceed 100, not adding');
      return false
    }
  }
